module.exports = __webpack_public_path__ + "img/trusted-alt.b5bea13.svg";